// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1viRu","footer":"ModalError_footer__dEPSo"};